import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

function Copyright() {
  return (
    <Typography variant="body2" color="#ffffff" align="right">
      {"Copyright © "}
      Hokuden Information Technology,
      {" Inc. All rights reserved."}
    </Typography>
  );
}

export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: "#43070e", py: 6, color: "#ffffff" }}>
      <Container maxWidth="lg">
        <Typography variant="subtitle1" align="left" gutterBottom>
          ほくでん情報テクノロジー株式会社 H-IX(北海道インターネット・エクスチェンジ)データセンター
        </Typography>
        <Typography variant="subtitle1" align="left" color="#ffffff" component="p">
          〒060-0041 北海道札幌市中央区大通東3丁目4 e・i 大通東ビル
        </Typography>
        <Typography variant="subtitle1" align="left" color="#ffffff" component="p">
          TEL. 011-330-7606
        </Typography>
        <Copyright />
      </Container>
    </Box>
  );
}
